import React from 'react'
import '../styles/interior.css';
import Kitchen2 from '../img/Kitchen/Kitchen 2.jpg'
import Kitchen3 from '../img/Kitchen/kitchen 3.jpg'
import Kitchen6 from '../img/Kitchen/Kitchen 6.jpg'
import Kitchen7 from '../img/Kitchen/Kitchen 7.jpg'
import Kitchen9 from '../img/Kitchen/Kitchen 9.jpg'
import Kitchen5 from '../img/Kitchen/Kitchen 5.jpg'
import {AnimationOnScroll} from 'react-animation-on-scroll'
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function Interior(props) {
  const location = useLocation();
    const componentRef = useRef(null);

    useEffect(() => {
        if (componentRef.current) {
            setTimeout(() => {

                componentRef.current.scrollIntoView({ behavior: "smooth" });
            }, 3000);
        }
    }, [location])


  return (
    <section ref={componentRef}>
      <div className="about">
        <h3 id="Content">{props.name}</h3>
      </div>
      <div className="my-3 KitchenImage">
        <img src={Kitchen2} alt="ReactJs" className="Kitchen" />
        <img src={Kitchen3} alt="ReactJs" className="Kitchen" />
        <img src={Kitchen6} alt="ReactJs" className="Kitchen" />
        <img src={Kitchen7} alt="ReactJs" className="Kitchen" />
        <img src={Kitchen9} alt="ReactJs" className="Kitchen" />
        <img src={Kitchen5} alt="ReactJs" className="Kitchen" />
      </div>
    </section>
  )
}

export default Interior
